import { stringFromPrefixedString } from "../utils";
import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.minLength(20), S.maxLength(255), S.brand("@open-revenue/schema/RedemptionCode"));
export const FromString = stringFromPrefixedString("redemption_", Schema);
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const generate = ()=>crypto.randomUUID();
const StringFromUrlParams = S.transform(S.Record({
    key: S.String,
    value: S.Union(S.String, S.Array(S.String))
}), S.Array(S.String), {
    decode: (x)=>{
        if (!x.codes) {
            return [];
        }
        if (S.is(S.String)(x.codes)) {
            return x.codes.split(",");
        }
        return x.codes.flatMap((code)=>code.split(","));
    },
    encode: (x)=>({
            codes: x
        }),
    strict: false
});
// In compose you match the type of schema 1 with the encoded of schema 2
// const schema1: S.Schema<string[], string, never> = S.asSchema(S.split(','), S.String)
// const schema2: S.Schema<number[], string[], never> = S.Array(S.NumberFromString)
// S.compose(schema1, schema2)
export const FromUrlParams = S.compose(StringFromUrlParams, S.Array(FromString));
